import React, { useState } from 'react'
import CallToAction from './CallToAction';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import About from './About';
import Banner from './Banner';
// import Blogs from './Blogs';
import PostTask from './PostTask';
import Testimonial from './Testimonial';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useRef } from 'react';
import { useEffect } from 'react';
import { CompleteBuyer, getTaskCategoryList, taskReviewBuyer } from '../../Redux/Task/action';
import ToasterMessage from '../ToasterMessage';
import { Button, Form, Modal } from 'react-bootstrap';
// import Values from './Values';
import { Rating } from 'react-simple-star-rating';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const Home = () => {

  const [toaster, setToaster] = useState("");
  const { state } = useLocation();
  const messagesEndRef = useRef(null);
  const [title, setTitle] = useState();
  const [taskdetailid, setTaskdetailid] = useState();
  const topRef = useRef(null);
  const navigate = useNavigate();
  const [category, setCategory] = useState();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [rating, setRating] = useState(0)
  // Catch Rating value
  const handleRating = (rate: number) => {
    setRating(rate)
    // other logic
  }
  useEffect(() => {
    if (state && state.task) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth", alignToTop: 'start' })
      navigate('/')
    }
    if (state?.login) {

      setToaster("Success")
      setTitle(state?.title)
      setTaskdetailid(state?.task_details)
      navigate('/')
      setTimeout(() => {
        setToaster("")
      }, 2000);
    }
    // state = {}
  }, [state]);

  useEffect(() => {
    getTaskCategoryList()((response) => {
      if (response && response.status) {
        setCategory(response?.data?.data)
      }
    });
    // var review = JSON.parse(localStorage.getItem('non_reviewed_task'));

    if (localStorage.getItem('view_rating')) {
      handleShow()
      localStorage.removeItem('view_rating');
    }
  }, []);
  const validationSchema = Yup.object().shape({
    // rating: Yup.string()
    //     .required('Required'),
    // comment: Yup.string()
    //     .required('Required'),
  });
  const formik = useFormik({
    initialValues: {
      rating: "",
      comment: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const task_details = taskdetailid
      // formData.append("cancel_reason", values.cancel_reason);
      taskReviewBuyer(rating, values?.comment, task_details)((response) => {
        if (response && response.status) {
          CompleteBuyer({ task_details })((response) => {
            if (response && response.status) {
              // getCompletedBuyer()
            }
          });
          navigate("/mytaskbuyer")
        }
        else {
          formik.setErrors({
            comment: response?.response?.data?.data?.errors?.comment
          })
        }

      });
    },
  });

  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ block: "start" });
  }, []);


  return (
    <React.Fragment>
      <ToasterMessage toaster={toaster} setToaster={setToaster} />
      <div ref={topRef}></div>
      <Header />
      <Banner categories={category} />
      {!localStorage.getItem('token') &&
        <React.Fragment>
          <About />
          <div ref={messagesEndRef}>
          </div>
          <PostTask state={state} categories={category} />
          <Testimonial state={state} categories={category} />
          {/* <Values/> */}
          <CallToAction />
          {/* <Blogs/> */}
        </React.Fragment>
      }
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>

        </Modal.Header>
        <Modal.Body>
          <h5>You might have missed providing a rating to {title} task.</h5>
          <Form onSubmit={formik.handleSubmit}>
            <h6 style={{ fontSize: "16px", fontWeight: "600" }}>Rate the seller</h6>
            <Form.Group className="mb-3 d-grid" controlId="exampleForm.ControlTextarea1">
              <Form.Label>Tap a star to set your rating</Form.Label>
              <Rating
                onClick={handleRating}
                // onPointerEnter={onPointerEnter}
                // onPointerLeave={onPointerLeave}
                // onPointerMove={onPointerMove}
                transition
              /* Available Props */
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
              <Form.Label>Enter comments:</Form.Label>
              <Form.Control
                as="textarea"
                name='comment'
                rows={3}
                onChange={formik.handleChange}
                isValid={formik.touched.comment && !formik.errors.comment}
                isInvalid={!!formik.errors.comment}
                value={formik.values?.comment}
              />
            </Form.Group>

            <div className='completed-task-btn text-center'>
              <Button type="submit" variant="primary" className='rate-now-btn btn btn-primary'>
                Rate Now
              </Button>
            </div>

          </Form>
        </Modal.Body>
      </Modal>
      <Footer />
    </React.Fragment>
  )
}

export default Home;